module.exports = __webpack_public_path__ + "assets/img/bind_suc_bg.edcc0548.png";